import React, { useRef, useState } from 'react';
import AuthLayout from './layout';
import { Link, useNavigate } from 'react-router-dom';
import { API_URL, APIS, URLS } from '../../_config';
import { Controller, useForm } from 'react-hook-form';
import Error from '../../components/formFieldError';
import toast from 'react-hot-toast';
import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA_SITE_KEY } from '../../_config/site_urls';

import { useUserApi } from '../../store/api/hooks/userApiHook';
import Icon from '../../components/icons';

const Login: React.FC = () => {
    const { control, formState: { errors }, handleSubmit, reset } = useForm();
    const navigate = useNavigate();
    const userAPI: any = useUserApi();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [captchaValue, setCaptchaValue] = useState(null);
    const recaptchaRef = useRef<ReCAPTCHA | null>(null);

    const [showPassword, setShowPassword] = React.useState(false);
    const handleCaptchaChange = (value: any) => {
        setCaptchaValue(value);
    };
    const submitLogin = (params: any) => {
        return new Promise((resolve, reject) => {
            // if (captchaValue) {
            userAPI.login(params, (msg: any, resp: any) => {
                if (resp?.status == 200) {
                    resolve(msg);
                    let resetValues = { name: '', email: '', message: '' }
                    reset(resetValues);
                    navigate(URLS.HOME);
                } else {
                    reject(msg);
                }
            }, (msg: any) => { 
                reject(msg);
            })



            // fetch(APIS.AUTH.LOGIN, {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json', },
            //     body: JSON.stringify(params),
            // }).then(response => response.json())
            //     .then(resp => {
            //         if (resp?.status == 200) {
            //             resolve(resp.message);
            //             let resetValues = { name: '', email: '', message: '' }
            //             reset(resetValues);
            //         } else {
            //             reject(resp.message);
            //         }
            //     })
            //     .catch(error => {
            //         // Handle error
            //         console.error('Error:', error);
            //         reject(error.message);
            //     });
            // } else {
            //     reject('Please verify the captcha.');
            // }

        })
    }

    const saubmitFormHandler = (data: any) => {
        console.log('Data:', data);
        toast.promise(submitLogin(data), {
            loading: 'Login...',
            success: (msg: any) => <b>{msg}</b>,
            error: (msg: any) => <b>{msg}</b>
        });
        // alert('Form submitted');
        // userAPI.login({}, (message: any, resp: any) => { }, (message: any, error: any) => { });
        console.log('Email:', email);
        console.log('Password:', password);
    }


    // const handleSubmit = (event: React.FormEvent) => {
    //     event.preventDefault();
    //     userAPI.login({},(message:any, resp:any)=>{},(message:any, error:any)=>{});
    //     console.log('Email:', email);
    //     console.log('Password:', password);
    // };

    return (
        <AuthLayout>
            <div className="login_logo">
                <a href="javascript:void(0);">
                    <img src="/assets/images/login/logo.png" />
                </a>
            </div>
            <h3>Sign In to Mortgage Support.</h3>
            <p>Enter your login details please</p>
            <form onSubmit={handleSubmit(saubmitFormHandler)}>
                <div className="form-group mb-3">
                    <Controller
                        defaultValue={""}
                        control={control}
                        name="email"
                        rules={{ required: 'Email is required', pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: "Invalid email address" } }}
                        render={({
                            field: { onChange, onBlur, value, name, ref },
                        }) => (
                            <input type="text" name={name}
                                onChange={onChange}
                                onBlur={onBlur}
                                value={value}
                                className="form-control" placeholder="Enter your Email Id"
                            />
                        )}
                    />
                    <span className="input_icon"><img src="/assets/images/login/New Letter.svg" /></span>
                    <Error error={errors["email"]} />
                </div>
                <div className="form-group mb-2">
                    <Controller
                        defaultValue={""}
                        control={control}
                        name="password"
                        rules={{ required: 'Password is required', minLength: { value: 6, message: 'Password must have at least 6 characters' } }}
                        render={({
                            field: { onChange, onBlur, value, name, ref },
                        }) => (
                            <input type={showPassword ? "text" : "password"} name={name}
                                onChange={onChange}
                                onBlur={onBlur}
                                value={value}
                                className="form-control" placeholder="Enter your Password" />
                        )}
                    />
                    <span className="input_icon"><Icon name={showPassword ? 'eye' : 'eye-off'} onClick={() => setShowPassword(!showPassword)} /> </span>
                    <Error error={errors["password"]} />
                </div>
                <div className="forget_text"><Link to={URLS.FORGOT_PASSWORD} >Forgot Password?</Link></div>
                <div className="notrobot">
                    <div className="form-check">
                        {/* <input className="form-check-input" type="checkbox" id="formCheck1" />
                        <label className="form-check-label" htmlFor="formCheck1">
                            I'm not a Robot
                        </label> */}
                        <ReCAPTCHA
                            sitekey={RECAPTCHA_SITE_KEY}
                            ref={recaptchaRef}
                            onChange={handleCaptchaChange}
                        />
                    </div>
                    {/* <div className="captcha">
                        <img src="/assets/images/login/recaptcha-icon 1.png" />
                    </div> */}

                </div>
                <button type="submit" className="loginBtn">log in</button>
            </form>
            <div className="create_account">
                New Here? <Link to={URLS.REGISTER}>Create an Account</Link>
            </div>
            <div className="login_copyright">© <script>document.write(new Date().getFullYear())</script> Mortgage Support  |  <a href="javascript:void(0);"> Policy</a>  |  <a href="javascript:void(0);"> Terms</a></div>
        </AuthLayout>
    );
};

export default Login;